export default "__VITE_ASSET__BjTci071__"